export const NEXUS_A_RECORDS_RESET_STATE = 'NEXUS_A_RECORDS_RESET_STATE';
export const NEXUS_A_RECORDS_CURRENT_ITEM = 'NEXUS_A_RECORDS_CURRENT_ITEM';

export const NEXUS_A_RECORDS_REQUEST_LOADING = 'NEXUS_A_RECORDS_REQUEST_LOADING';
export const NEXUS_A_RECORDS_REQUEST_SUCCESS = 'NEXUS_A_RECORDS_REQUEST_SUCCESS';
export const NEXUS_A_RECORDS_REQUEST_FAILED = 'NEXUS_A_RECORDS_REQUEST_FAILED';

export const NEXUS_A_RECORDS_CURRENT_ACTION = 'NEXUS_A_RECORDS_CURRENT_ACTION';
export const NEXUS_A_RECORDS_RESET_ACTION = 'NEXUS_A_RECORDS_RESET_ACTION';